import { camelCase } from 'lodash';
import Papa from 'papaparse';
import { api } from '$app/api';

const propertyConfig = [
  {key: 'accountCode', required: true, fieldType: 'number'},
  {key: 'contactName', required: true, fieldType: 'string'},
  {key: 'description', required: true, fieldType: 'string'},
  {key: 'dueDate', required: true, fieldType: 'string'},
  {key: 'invoiceDate', required: true, fieldType: 'string'},
  {key: 'invoiceNumber', required: true, fieldType: 'string'},
  {key: 'quantity', required: true, fieldType: 'number'},
  {key: 'taxType', required: true, fieldType: 'string'},
  {key: 'unitPrice', required: true, fieldType: 'number'},
  {key: 'unitAmount', required: true, fieldType: 'number'},
  {key: 'driverUuid', required: true, fieldType: 'string'},
  {key: 'startDate', required: true, fieldType: 'string'},
  {key: 'endDate', required: true, fieldType: 'string'},
];

const useCorrectFieldType = (fieldValue, fieldKey) => {
  const property = propertyConfig.find((knownProperty) => knownProperty.key === fieldKey);

  if(property?.fieldType === 'number') return Number(fieldValue);

  return fieldValue;
}

export const transformData = (rawInvoiceRecords) => {
  return rawInvoiceRecords.map((invoiceRecord) => {
    return Object.keys(invoiceRecord).reduce((transformedRow, originalKey) => {
      const originalValue = invoiceRecord[originalKey];
      const newKey = camelCase(originalKey.replace('*', ''));
      const newValue = useCorrectFieldType(originalValue, newKey);

      transformedRow[newKey] = newValue;
      return transformedRow;
    }, {});
  });
}

export const parseData = (file) =>
  new Promise((resolve, reject) =>
    Papa.parse(file, {
      header: true,
      complete: (result) => resolve(result.data),
      error: (error) => reject(error),
    })
  );

export const sendDriverInvoicingRequest = async (driverInvoiceRecords) =>
  api.post(`/drivers/invoicing`, {
    eventType: 'DriverInvoicingRequest',
    body: { driverInvoiceRecords },
  });

export const isDataValid = (data) => {
  const requiredProperties = propertyConfig.filter(({ required }) => required === true);

  const allRowsHaveRequiredProperties = data.every((invoiceRecord) =>
    requiredProperties.every(({ key }) => Boolean(invoiceRecord[key]))
  );

  return allRowsHaveRequiredProperties;
};